import { render, staticRenderFns } from "./GameContent.vue?vue&type=template&id=1b0e2c1a&scoped=true"
import script from "./GameContent.vue?vue&type=script&lang=js"
export * from "./GameContent.vue?vue&type=script&lang=js"
import style0 from "./GameContent.vue?vue&type=style&index=0&id=1b0e2c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e2c1a",
  null
  
)

export default component.exports